import httpClient, { ConexaResponse } from '@/services/httpClient'
import { RealtimeAppointmentStatus } from '../types'

export const RealtimeAttendanceMonitoringService = {
  getAppointmentStatus: async (
    patientId: number | string,
  ): Promise<RealtimeAppointmentStatus[]> => {
    const response = await httpClient.get<
      ConexaResponse<RealtimeAppointmentStatus[]>
    >(`/app-paciente/fluxos/pacientes/${patientId}/status`)

    return response?.data?.object
  },
}
